export class SeoError extends Error {}
